<template>
  <header class="header">
    <div class="left">
      <span class="logo">可乐基金</span>
      <ul class="navs">
        <li><router-link to="/">首页</router-link></li>
        <li><router-link to="/wallet">钱包</router-link></li>
        <li>
          <el-dropdown
            @command="handleTradeNav"
            placement="top"
            size="medium"
            :hide-timeout="250"
            :show-timeout="150"
          >
            <span class="el-dropdown-link">交易</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/trade/btc-usdt">币币交易</el-dropdown-item>
              <!-- <el-dropdown-item command="/swap/usd-btc">永续合约</el-dropdown-item> -->
              <el-dropdown-item command="/futures-usd/btc-weekly">交割币本位合约</el-dropdown-item>
              <el-dropdown-item command="/futures-usdt/btc-weekly">交割U本位合约</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li><router-link to="/user">用户管理</router-link></li>
        <!-- <li><router-link to="/login">login</router-link></li> -->
        <li class="empty-block" />
      </ul>
    </div>
    <el-dropdown
      v-if="isLogin"
      @command="handleLogout"
      class="right"
      placement="top"
      size="medium"
      :hide-timeout="250"
      :show-timeout="150"
    >
      <span class="el-dropdown-item"> {{ username }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div v-else class="noLogin" />
  </header>
</template>

<script>
import { getUsername, getToken } from 'utils/storage';

export default {
  name: 'global-header',
  data() {
    return {
      isLogin: getToken(),
      username: getUsername() || 'anonymous',
    };
  },
  computed: {},
  watch: {},
  mounted() {
    // hack 不使用vuex，没有太好的办法全局更新组件。这里把实例给到window，login后从window上set header data
    window.globalHeader = this;
  },
  updated() {},
  methods: {
    handleTradeNav(cmd) {
      this.$router.push({ path: `${cmd}` });
    },
    handleLogout(cmd) {
      if (cmd === 'logout') {
        localStorage.clear();
        this.isLogin = false;
        this.username = 'user';
        this.$router.push({ path: '/login' });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../styles/consts.less';

.el-dropdown-link {
  font-size: 16px;
  font-weight: bold;
  color: #2c3e50;
  cursor: pointer;
}
.el-dropdown-item {
  color: #2c3e50;
  cursor: pointer;
}
.header {
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  border-bottom: 1px solid #fefefe;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.25);
  .left {
    display: flex;
    justify-content: space-between;
  }
  .logo {
    font-weight: bold;
    margin-right: 24px;
  }
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: @themeColor;
    }
  }
  ul {
    display: flex;
    li {
      margin: 0 6px;
    }
    .empty-block {
      display: inline-block;
      flex-grow: 1;
    }
  }
  .noLogin {
    display: inline-block;
    width: 48px;
  }
}
</style>
